

const AnchorLink = ({title,href,className="btn btn-primary",target="_self",icon:Icon,iconPostion='left'}) => {
    return (
        <>
            <a href={href} className={className} target={target}>

                {iconPostion === 'left' &&
                    Icon || ''
                }
                { title }

                {iconPostion === 'right' &&
                    Icon || ''
                }                
            </a>
        </>
    );
};

export default AnchorLink;